'use client';

import { useState } from 'react';
import { useParams } from 'next/navigation';
import { useQuery } from '@apollo/client/react';
import Loading from '@/components/loading';
import ErrorMessage from '@/components/error-message';
import NotFound from '@/components/not-found';
import { eventAttendeesQuery } from '@/apollo/events';
import { extractId } from '@/utils/slugify';
import VerticalTabs from '@/components/vertical-tabs';
import AttendeesTab from '@/components/events/attendees-tab';
import InvitesTab from '@/components/events/invites-tab';

const EventAttendeesPageClient = () => {
  const { id: rawId } = useParams();
  const id = extractId(rawId as string);
  const [currentTab, setCurrentTab] = useState('members');

  const { data, loading, error } = useQuery(eventAttendeesQuery, {
    variables: {
      id
    },
    ssr: false,
  });
  const event = data?.event;

  if (loading) { return <Loading />; }
  if (error) {
    return <ErrorMessage message='An error occurred while loading event.' error={error} />;
  }
  if (!event || !event.permissions.attendeesViewable) { return <NotFound />; }

  return (
    <>
      {event.permissions.editable ? (
        <VerticalTabs
          tabs={[
            { label: 'Members', tab: 'members' },
            { label: 'Invites', tab: 'invites' },
          ]}
          currentTab={currentTab}
          onChange={(e, newTab) => setCurrentTab(newTab)}
        >
          <VerticalTabs.TabPanel tab="members" currentTab={currentTab}>
            <AttendeesTab event={event} />
          </VerticalTabs.TabPanel>

          <VerticalTabs.TabPanel tab="invites" currentTab={currentTab}>
            <InvitesTab event={event} />
          </VerticalTabs.TabPanel>
        </VerticalTabs>
      ) : (
        <AttendeesTab event={event} />
      )}
    </>
  );
};

export default EventAttendeesPageClient;
